import PropTypes from "prop-types"
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { MAX_TABLE_PREVIEW_ROWS } from "../../../helpers/constants"

export default function PreviewTable({ columns, rows }) {
  return <TableContainer className="table-artifact-preview" component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map(({ headerName }) => <TableCell key={headerName}>{headerName}</TableCell>)}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.slice(0, MAX_TABLE_PREVIEW_ROWS).map((row) => <TableRow key={row.id}>
          {columns.map(({ field, valueFormatter }) => <TableCell key={field}>{valueFormatter(row[field])}</TableCell>)}
        </TableRow>)}
      </TableBody>
    </Table>
  </TableContainer>
}

PreviewTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
}
